import _default from './Rating';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/modules/Rating/index.js
// module id = 2869
// module chunks = 0